export default {
  selectedItemIndex: null,
  selectedLanguage: null,
  template: null,
  templates: null,
  totalTemplates: null
};
